export const size_list = [
  {
    text: "SM",
    value: "small",
    id: 1,
    name: "size",
  },
  {
    text: "MD",
    value: "medium",
    id: 2,
    name: "size",
  },
  {
    text: "LG",
    value: "large",
    id: 3,
    name: "size",
  },
];
